import { axiosInstance } from '../config/axiosConfig';
import { API_ENDPOINTS } from '../endpoints/endpoints';

export interface Favorite {
  id: string;
  listingId: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
  listing?: any; // Full listing data when fetched with details
}

export interface FavoritesResponse {
  favorites: Favorite[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const favoritesService = {
  // Get all favorites for the current user
  getFavorites: async (page = 1, limit = 10): Promise<FavoritesResponse> => {
    const { data } = await axiosInstance.get<{
      success: boolean;
      data: FavoritesResponse;
    }>(API_ENDPOINTS.FAVORITES.GET_ALL, { params: { page, limit } });
    return data.data;
  },

  // Add a listing to favorites
  addFavorite: async (listingId: string): Promise<Favorite> => {
    const { data } = await axiosInstance.post<{
      success: boolean;
      data: Favorite;
    }>(API_ENDPOINTS.FAVORITES.ADD, { listingId });
    return data.data;
  },

  // Remove a listing from favorites
  removeFavorite: async (listingId: string): Promise<void> => {
    await axiosInstance.delete(API_ENDPOINTS.FAVORITES.REMOVE(listingId));
  },

  // Check if a listing is favorited
  isFavorite: async (listingId: string): Promise<boolean> => {
    try {
      const { data } = await axiosInstance.get<{
        success: boolean;
        data: { isFavorite: boolean };
      }>(API_ENDPOINTS.FAVORITES.CHECK(listingId));
      return data.data.isFavorite;
    } catch (error) {
      return false;
    }
  },

  // Get favorite IDs for multiple listings (batch check)
  getFavoriteIds: async (): Promise<string[]> => {
    try {
      const { data } = await axiosInstance.get<{
        success: boolean;
        data: { listingIds: string[] };
      }>(API_ENDPOINTS.FAVORITES.IDS);
      return data.data.listingIds;
    } catch (error) {
      return [];
    }
  },
};
